export default {
  data() {
    return {
      shouldSuppress: null,
    };
  },

  methods: {
    box(title, messageText, suppressKey, okTitle, cancelTitle) {
      this.shouldSuppress = this.getLocalStorageItem(suppressKey);
      if (this.shouldSuppress) return Promise.resolve(true);
      const h = this.$createElement;
      const self = this;
      const messageVNode = h('div', [
        h('p', messageText),
        h('div', {
          class: 'alert alert-warning',
        }, [
          h('input', {
            attrs: {
              id: 'confirm-check',
              name: 'confirm-check',
              type: 'checkbox',
              class: 'mr-2',
            },
            domProps: {
              checked: self.shouldSuppress,
            },
            on: {
              input(event) {
                self.shouldSuppress = event.target.checked;
                self.setLocalStorageItem(suppressKey, event.target.checked);
              },
            },
          }), h('small', 'Don\'t show this message again.'),
        ]),
      ]);
      if (cancelTitle === undefined) {
        return this.$bvModal.msgBoxOk([messageVNode], {
          title,
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle,
          dialogClass: 'warning-dialog',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        });
      }
      return this.$bvModal.msgBoxConfirm([messageVNode], {
        title,
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle,
        cancelTitle,
        dialogClass: 'confirmation-dialog',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        ref: 'modal',
      });
    },
    boxOk(title, messageText, suppressKey) {
      return this.box(title, messageText, suppressKey, 'OK');
    },
    boxConfirm(title, messageText, suppressKey) {
      return this.box(title, messageText, suppressKey, 'YES', 'NO');
    },
    getLocalStorageItem(itemKey) {
      return localStorage.getItem(itemKey);
    },
    setLocalStorageItem(itemKey, itemValue) {
      if (itemValue) {
        localStorage.setItem(itemKey, JSON.stringify(itemValue));
      } else {
        localStorage.removeItem(itemKey);
      }
    },
  },
};
